import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'rapport-dialog',
    templateUrl: 'rapport-dialog.component.html',
    styleUrls: ['rapport-dialog.component.scss', '../rapports.scss']
})
export class RapportDialog implements OnInit {
    
    dossier: any;
    rapportStep: any = "";
    subscribe: any = [];
    messageError: string = "";
    rapport: any;
    fragments: any;
    nameRapport: string = "";
    fileurl: string;
    name: any;

    constructor(
        private appService: AppService,
        public dialogRef: MatDialogRef<RapportDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        console.log("data dialog ===+>",this.data)
        this.dossier = this.data.dossier
        this.rapport = this.data.rapport
        this.fragments = this.data.fragments || []
        this.nameRapport = this.data.nameRapport

        setTimeout(() => {
            const node = document.createElement('script');
            node.src = '/assets/main.js'
            node.type = 'text/javascript';
            node.id = 'cobhamjsexjs';
            document.getElementsByTagName('head')[0].appendChild(node);
        }, 1000)

    }
    printRap(){
        /* #2085 */
        /* pour pouvoir imprimer l'ensemble des pages, il faut ouvrir le contenu de la div dans un nouvel onglet */
        let printWindow = window.open('', 'PRINT');

        printWindow.document.write(document.querySelector('.rapport-display').innerHTML);
    
        printWindow.document.close(); // necessary for IE >= 10
        printWindow.focus(); // necessary for IE >= 10*/
    
        printWindow.print();
        printWindow.close();
    
        return true;
    }
    downloadRapport(type){
        window['tryga']('send', 'event', 'rapports', 'export_' + type, this.nameRapport, '');

        if(this.subscribe && this.subscribe['downloadrapport']){
            this.subscribe['downloadrapport'].unsubscribe();
        }
        //nom_prenom_client_type-rapport_date-generation
        let dategeneration = new Date().toLocaleDateString("fr-FR", {hour:"2-digit", minute:"2-digit", second:"2-digit"})
        this.name = this.dossier.nom+"_"+this.dossier.prenom+"_"+this.nameRapport+"_"+dategeneration+'.'+type.toLowerCase()
        this.name = this.name.replace(' ', '_')
        this.subscribe['downloadrapport'] = this.appService.downloadrapport(this.dossier.id,this.nameRapport, type).subscribe((res)=>{
            if(res){
/* #1551 problème avec SAFARI
                let blob;
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if(type == "PDF"){
                        blob = new Blob([res], { type: 'application/pdf' })
                    }else{
                        blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
                    }
                    window.navigator.msSaveOrOpenBlob(blob, this.name);
                } else {// other browsers
                    if(type == "PDF"){
                        blob = new File([res], this.name, {type: "application/pdf"});
                    }else{ 
                        blob = new File([res], this.name, {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"});
                    }
                    let exportUrl = window.URL.createObjectURL(blob);
                    window.open(exportUrl);
                    URL.revokeObjectURL(exportUrl);
                }
*/
                let aDownload = document.createElement('a')
                aDownload.download = this.name
                aDownload.href = URL.createObjectURL(res)
                document.body.appendChild(aDownload)
                aDownload.click()
                document.body.removeChild(aDownload)
            }else{
                this.messageError = "Une erreur est survenue lors de l'export du rapport.";
                setTimeout(()=>{this.messageError = ""}, 5000);
            }
            
        },err=>{
            this.messageError = "Une erreur est survenue lors de l'export du rapport.";
                setTimeout(()=>{this.messageError = ""}, 5000);
        })
    }
    dismissDialog(){
        document.getElementById('cobhamjsexjs').remove();
        this.dialogRef.close();
    }

    analyseRapportClick(e){
        console.log('rapport-click')
        let element = e.target
        // cas de l'ouverture de la popup
        if (element.classList &&
            (element.classList.contains('bible-anchor'))
        ) {
            window['tryga']('send', 'event', 'rapports', 'bible_ouverture', element.getAttribute('data-ids'), ''); // #2235 GA sur les fragments de bible
            return
        }
        let btn = null
        let count = 3
        do {
            if (element.classList &&
                (element.classList.contains('btn-ajout') || element.classList.contains('btn-supp'))
            ) {
                btn = element
            }
            element = element.parentElement
            console.log(count)
        } while (btn == null && count-- > 0);
        if (!btn) {
            return
        }

        let action    = btn.classList.contains('btn-supp') ? 1 : 0
        let newFargs = btn.getAttribute('data-ids')
        if (newFargs.indexOf(',') > -1) {
            newFargs = newFargs.split(',')
        }
        else {
            newFargs = [newFargs]
        }
console.log(action, newFargs, this.fragments)
        newFargs.forEach((newFrag) => {
            if (action == 1) {
                if (this.fragments.indexOf(newFrag) > -1) {
                    delete this.fragments[this.fragments.indexOf(newFrag)];
                    window['tryga']('send', 'event', 'rapports', 'bible_deselection', newFrag, ''); // #2235 GA sur les fragments de bible
                }
            }
            else {
                if (this.fragments.indexOf(newFrag) == -1) {
                    this.fragments.push(newFrag)
                    window['tryga']('send', 'event', 'rapports', 'bible_selection', newFrag, ''); // #2235 GA sur les fragments de bible
                }
            }
        })
        this.fragments = this.fragments.filter(e=>e) // retirer les éléments vide
console.log(this.fragments)
        this.appService.setBibleSnippet(this.dossier.id,this.nameRapport, this.fragments).subscribe((res)=>{
            console.log(res)
        })
    }
}